'use strict';


export default function($log, $compile, $parse, $timeout, $animate) {
	'ngInject';

	return {
		require: '^form',
		transclude: true,
		link: postLink,
		scope: true,
	};

	function postLink(scope, element, attrs, $form, transclude) {
		scope.$errors = $form.$rest.$errors;
		transclude(scope, function(clone, scope) {
			element.append(clone);
		});
	}
}
